import { render, staticRenderFns } from "./Palestras.vue?vue&type=template&id=262a513c&scoped=true&"
import script from "./Palestras.vue?vue&type=script&lang=ts&"
export * from "./Palestras.vue?vue&type=script&lang=ts&"
import style0 from "./Palestras.vue?vue&type=style&index=0&id=262a513c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262a513c",
  null
  
)

export default component.exports